import { PropTypes } from 'prop-types';

import ZuiContainer from '@zenbusiness/zui/Container';
import { superstyled } from '@zenbusiness/zui/styles';

const Container = superstyled({
  name: 'RootLayout',
  slot: 'Container',
  tag: ZuiContainer,
  styles: ({ theme }) => ({
    paddingInline: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      paddingInline: theme.spacing(4)
    },

    [theme.breakpoints.up('lg')]: {
      paddingInline: theme.spacing(8)
    }
  })
});

export function RootLayout({ children, maxWidth = 'lg', ...delegated }) {
  return (
    <Container disableGutters maxWidth={maxWidth} {...delegated}>
      {children}
    </Container>
  );
}

RootLayout.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.string
};
